













import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { NAME } from './constants';
import { store } from './store/list';


const ROW_KEY = '6';

export default listFactory(NAME, store).extend({
	data() {
		return {
			rowKey: ROW_KEY,
		};
	},
	methods: {
		editClick(event: any) {
			openEdit(NAME, PageMode.EDIT, { id: event.data.ZAZNAM_ID });
		},
		viewClick(event: any) {
			openEdit(NAME, PageMode.VIEW, { id: event.data.ZAZNAM_ID });
		},
	},
});
